import { createReducer } from "redux-act";

import * as a from "../actions/announcements";

const getDefaultState = () => ({
  announcements: null,
  isLoadingAnnouncements: false,
});

export default () =>
  createReducer(
    {
      [a.getAnnouncements]: (state) => {
        return {
          ...state,
          isLoadingAnnouncements: true,
        };
      },
      [a.receivedAnnouncements]: (state, announcements) => {
        return {
          ...state,
          isLoadingAnnouncements: false,
          announcements,
        };
      },
      [a.getAnnouncementsError]: (state) => ({
        ...state,
        isLoadingAnnouncements: false,
      }),
    },
    getDefaultState()
  );
